export default "__VITE_ASSET__211b0270__"